import styled from '@emotion/styled';

import { mq } from '@hrworks/design-system/utilities';

const componentConfig = {
  sidebar: {
    horizontalPadding: 20,
    width: 255,
  },
  header: {
    height: 70,
    logoWidth: 120,
  },
};

const LayoutContainer = styled.div<{ isSidebarCollapsed: boolean }>(({ theme, isSidebarCollapsed }) => ({
  display: 'grid',
  gridTemplateAreas: `
    'header  header'
    'sidebar content'
  `,
  gridTemplateColumns: `${componentConfig.sidebar.width}px 1fr`,
  ...(isSidebarCollapsed && {
    gridTemplateColumns: '0 1fr',
  }),
  gridTemplateRows: `${componentConfig.header.height}px 1fr`,
  [mq.conditionalTransition]: {
    transition: `grid-template-columns ${theme.marko.variables.animationDuration.long}`,
  },

  width: '100%',
  height: '100%',

  [mq.isSmallDevice]: {
    gridTemplateAreas: `
      'header'
      'content'
    `,
    gridTemplateColumns: '1fr',
  },
}));

export const S = {
  componentConfig,
  LayoutContainer,
} as const;
